import loadable from 'react-loadable'
import i18n from '@signavio/i18n'

import { createLoadingMessage } from '@signavio/effektif-commons'

const Overview = loadable({
  loader: () => import(/* webpackChunkName: "process-overview" */ './Overview'),
  loading: createLoadingMessage(() => ({
    loading: i18n('Preparing workflow overview...'),
  })),
})

export { default as ProcessTile } from './ProcessTile'
export default Overview
